import Input from "../../../../components/Input/Input";

const Number = ({id, formik, settings = {}}) => {
    const inputElement = document.getElementById(id);

    if (inputElement) {
        inputElement.addEventListener('keypress', (e) => {
            if (isNaN(e.key))
                e.preventDefault();
        });
    }

    return (
        <Input
            id={id}
            name={id}
            label={settings.title}
            type="number"
            className="form"
            required={settings.required}
            value={formik.values[id]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            description={settings.description}
            error={formik.touched[id] && formik.errors[id]}
        />
    )
};

export default Number;